import React from 'react';

export default function Loader({ minHeight = 500 }) {
  return (
    <div className="loading-container" style={{ minHeight: minHeight }}>
      <div className="loading loading--circle-bounce is-loading">
        {[...Array(3).keys()].map((_, index) => (
          <div key={index} className="loading__ball"></div>
        ))}
      </div>
    </div>
  );
}
